"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8771],{

/***/ 8771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6677);
/* harmony import */ var _utils_htmlUtil_htmlFooterDT__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7460);



var FooterFareFinderDT = function(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, footerData = ref.footer_data;
    var footerFareFinder = _utils_htmlUtil_htmlFooterDT__WEBPACK_IMPORTED_MODULE_2__/* .footerFareFinderDT */ .ib;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            id: "footer_block",
            children: footerData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
                className: "paddingTop30 appendTop30",
                children: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_1__/* .transformToHtml */ .cR)(footerData)
            }) : (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_1__/* .transformToHtml */ .cR)(footerFareFinder)
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FooterFareFinderDT);


/***/ })

}]);